<template>
  <div>
    <div class="p-case" v-for="(item,index) in listData" :key="index">
      <img class="p-case-img" :src="item.headImage" alt="">
      <div class="p-content">
        <p class="p-case-title">{{item.title}}</p>
        <p class="p-case-content">{{item.content}}</p>
        <button class="p-case-btn"><a :href="item.linkUrl" style="color:#3266DB;">详情</a></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      listData:[],
      total:'',
      pageNum:1
    }
  },
  methods:{
     getInformation() {
       this.$HTTP.POST('https://portalapi.chinachdu.com/sysinfo/api/v1/publishcase/getall', {pageNum: 1,pageSize: 10}).then(res=>{
            console.log(res)
            this.listData = res.pageData
        }).catch(err=>{
            console.log(err, 'err')
        })
    }
  },
  created(){
    this.getInformation()
  }
}
</script>

<style lang="less" scoped>
  .p-case{
    display:flex;
    justify-content: flex-start;
    width:806px;
    height:176px;
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 12px 4px rgba(14,117,222,0.04);
    padding:22px 24px 6px 12px;
    margin:0 auto 6px;
  }
  .p-case-img{
    width:222px;
    height:148px;
    margin-right:72px;
  }
  .p-content{
    position:relative;
    width:512px;
    letter-spacing:1px;
  }
  .p-case-title{
    height:50px;
    font-size:18px;
    text-align:left;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:26px;
    margin-bottom:3px;
    overflow:hidden;
  }
  .p-case-content{
    height:46px;
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:26px;
    text-align:left;
    overflow:hidden;
  }
  .p-case-btn{
    display:block;
    width:86px;
    height:26px;
    color:#3266DB;
    font-size:16px;
    border-radius: 14px;
    text-align:center;
    line-height:26px;
    border:1px solid rgba(41,105,227,1);
    border-color:linear-gradient(0deg,rgba(22,156,250,1),rgba(65,98,205,1));
    left:45%;
    position: absolute;
    bottom:6px;
  }
  .p-case:nth-child(3){
    img{
      transform: scaleX(1.9);
    }
  }
  .p-case:nth-child(2){
    img{
      transform: scaleY(1.2);
    }
  }
  .p-case:nth-child(4){
    img{
      transform: scaleX(1.4);
    }
  }
  .p-case:nth-child(1){
    img{
      transform: scaleX(1.1);
    }
  }
  .p-case:nth-child(5){
    img{
      transform: scaleX(1.1);
    }
  }
  .p-case:nth-child(6){
    img{
      transform: scaleX(1);
    }
  }
</style>
